(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const SECTIONS = 'cart-drawer,main-cart';

    const drawer = () => document.querySelector('[data-cart-drawer]');
    const openDrawer = () => {
      const d = drawer();
      if (!d) return;
      d.hidden = false;
      document.body.style.overflow = 'hidden';
      const panel = d.querySelector('[data-cart-panel]');
      if (panel) panel.focus();
    };
    const closeDrawer = () => {
      const d = drawer();
      if (!d) return;
      d.hidden = true;
      document.body.style.overflow = '';
    };

    const swap = (sections) => {
      if (!sections) return;
      if (sections['cart-drawer']) {
        const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const fresh = parsed.querySelector('[data-cart-drawer]');
        const current = drawer();
        if (fresh && current) {
          const wasOpen = !current.hidden;
          current.replaceWith(fresh);
          fresh.hidden = !wasOpen;
        }
      }
      if (sections['main-cart']) {
        const parsed = new DOMParser().parseFromString(sections['main-cart'], 'text/html');
        const fresh = parsed.querySelector('[data-main-cart]');
        const current = document.querySelector('[data-main-cart]');
        if (fresh && current) current.replaceWith(fresh);
      }
    };

    const refreshCount = async () => {
      try {
        const res = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await res.json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = '(' + cart.item_count + ')';
        });
      } catch (e) { /* the count is cosmetic; the cart itself is Shopify's */ }
    };

    const change = async (key, quantity) => {
      const line = document.querySelector('[data-line-key="' + key + '"]');
      if (line) line.setAttribute('data-pending', '');
      try {
        const res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity, sections: SECTIONS }),
        });
        const data = await res.json();
        swap(data.sections);
        await refreshCount();
      } catch (e) {
        window.location.href = window.Shopify.routes.root + 'cart';
      }
    };

    document.addEventListener('click', (event) => {
      const closer = event.target.closest('[data-cart-close]');
      if (closer) {
        if (closer.tagName !== 'A') event.preventDefault();
        closeDrawer();
        if (closer.tagName === 'A') window.location.href = closer.getAttribute('href');
        return;
      }

      const opener = event.target.closest('[data-cart-open]');
      if (opener) {
        event.preventDefault();
        openDrawer();
        return;
      }

      const changer = event.target.closest('[data-cart-change]');
      if (changer) {
        event.preventDefault();
        change(changer.dataset.cartChange, Number(changer.dataset.cartQuantity));
      }
    });

    document.addEventListener('keydown', (event) => {
      const d = drawer();
      if (event.key === 'Escape' && d && !d.hidden) closeDrawer();
    });

    // Add to bag from the PDP: post to Shopify, then open the bag the shopper
    // just changed. Falls back to a normal form POST if anything goes wrong.
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form[action$="/cart/add"]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;
      try {
        const body = new FormData(form);
        body.append('sections', SECTIONS);
        const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: body,
        });
        const data = await res.json();
        if (data.status) throw new Error(data.description || data.message);
        swap(data.sections);
        await refreshCount();
        openDrawer();
      } catch (e) {
        form.submit();
      } finally {
        if (button) button.disabled = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const nav = document.querySelector('[data-nav]');
    if (!nav) return;

    const solid = nav.querySelector('[data-nav-solid]');
    const isTransparent = nav.classList.contains('nav--transparent');

    if (isTransparent && solid) {
      let raf = 0;
      const onScroll = () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const p = Math.min(1, Math.max(0, window.scrollY / 220));
          solid.style.opacity = String(p * p * (3 - 2 * p));
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    const drawer = document.querySelector('[data-nav-drawer]');
    const panel = drawer && drawer.querySelector('[data-nav-panel]');
    const trigger = nav.querySelector('[data-nav-open]');
    if (!drawer || !panel || !trigger) return;

    const close = () => {
      drawer.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      trigger.focus();
    };

    trigger.addEventListener('click', () => {
      drawer.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      panel.focus();
    });

    drawer.querySelectorAll('[data-nav-close]').forEach((el) => {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !drawer.hidden) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bg = document.querySelector('[data-hero-bg]');
    const content = document.querySelector('[data-hero-content]');
    if (!bg || !content) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const y = window.scrollY;
        bg.style.transform = 'translateY(' + y * 0.35 + 'px) scale(1.08)';
        content.style.opacity = String(Math.max(0, 1 - y / 600));
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const data = document.querySelector('[data-pdp-variants]');
    if (!data) return;

    let variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    const LOW_STOCK = 10;
    const idInput = document.querySelector('[data-pdp-variant-id]');
    const addBtn = document.querySelector('[data-pdp-add]');
    const addLabel = document.querySelector('[data-pdp-add-label]');
    const waitlist = document.querySelector('[data-pdp-waitlist]');
    const stock = document.querySelector('[data-pdp-stock]');
    const price = document.querySelector('[data-pdp-price]');
    const comparePrice = document.querySelector('[data-pdp-compare-price]');
    const discountPrice = document.querySelector('[data-pdp-discount-price]');
    const discountBadge = document.querySelector('[data-pdp-discount-badge]');
    const priceRow = document.querySelector('.pdp__price-row');
    const pills = [...document.querySelectorAll('[data-size-value]')];

    const labels = {
      add: addLabel ? addLabel.dataset.add : '',
      soldOut: addLabel ? addLabel.dataset.soldOut : '',
    };

    const DISCOUNT_KEY = 'be_discount';
    const DISCOUNTS = {
      DAYONES: { type: 'percent', value: 10 },
    };

    const detectDiscountSync = () => {
      const path = window.location.pathname;
      const params = new URLSearchParams(window.location.search);
      const pathMatch = path.match(/^\/discount\/([A-Za-z0-9_-]+)/i);
      if (pathMatch) {
        const code = pathMatch[1].toUpperCase();
        try { localStorage.setItem(DISCOUNT_KEY, code); } catch (e) {}
        return code;
      }
      const paramCode = params.get('discount');
      if (paramCode) {
        const code = paramCode.toUpperCase();
        try { localStorage.setItem(DISCOUNT_KEY, code); } catch (e) {}
        return code;
      }
      try { return localStorage.getItem(DISCOUNT_KEY); } catch (e) { return null; }
    };

    const detectDiscountFromCart = async () => {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        if (cart.discount_codes && cart.discount_codes.length > 0) {
          const code = cart.discount_codes[0].code.toUpperCase();
          try { localStorage.setItem(DISCOUNT_KEY, code); } catch (e) {}
          return code;
        }
      } catch (e) {}
      return null;
    };

    let discountCode = detectDiscountSync();
    let discount = discountCode ? DISCOUNTS[discountCode] : null;

    const formatMoney = (cents) => {
      const dollars = Math.round(cents) / 100;
      return '$' + (Number.isInteger(dollars) ? dollars : dollars.toFixed(2));
    };

    const applyDiscountDisplay = (priceCents) => {
      if (!discount || !discountPrice || !discountBadge || !priceCents) return;
      let finalCents = priceCents;
      if (discount.type === 'percent') {
        finalCents = Math.round(priceCents * (1 - discount.value / 100));
      } else if (discount.type === 'fixed') {
        finalCents = Math.max(0, priceCents - discount.value * 100);
      }
      if (finalCents < priceCents) {
        price.classList.add('pdp__price--discounted');
        discountPrice.textContent = formatMoney(finalCents);
        discountPrice.hidden = false;
        discountBadge.textContent = discountCode + ' applied';
        discountBadge.hidden = false;
      } else {
        price.classList.remove('pdp__price--discounted');
        discountPrice.hidden = true;
        discountBadge.hidden = true;
      }
    };

    const clearDiscountDisplay = () => {
      if (price) price.classList.remove('pdp__price--discounted');
      if (discountPrice) discountPrice.hidden = true;
      if (discountBadge) discountBadge.hidden = true;
    };

    const apply = (variant) => {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (price && variant.price) {
        price.textContent = variant.price;
        price.dataset.rawCents = variant.priceCents;
      }

      if (priceRow) {
        let cmp = priceRow.querySelector('[data-pdp-compare-price]');
        if (variant.compareAtPrice) {
          if (!cmp) {
            cmp = document.createElement('span');
            cmp.className = 'pdp__compare-price';
            cmp.setAttribute('data-pdp-compare-price', '');
            priceRow.insertBefore(cmp, priceRow.firstChild);
          }
          cmp.textContent = variant.compareAtPrice;
        } else if (cmp) {
          cmp.remove();
        }
      }

      if (discount && variant.priceCents) {
        applyDiscountDisplay(variant.priceCents);
      } else {
        clearDiscountDisplay();
      }

      const available = !!variant.available;
      if (addBtn) addBtn.disabled = !available;
      if (addLabel) addLabel.textContent = available ? labels.add : labels.soldOut;
      if (waitlist) waitlist.hidden = available;

      if (stock) {
        const n = variant.inventory;
        const tracked = variant.managed !== null && variant.managed !== '';
        const show = available && tracked && typeof n === 'number' && n > 0 && n < LOW_STOCK;
        stock.hidden = !show;
        if (show) stock.textContent = stock.dataset.template.replace('[count]', String(n));
      }
    };

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        const value = pill.dataset.sizeValue;
        pills.forEach((p) => {
          const on = p === pill;
          p.classList.toggle('size-selector__pill--selected', on);
          p.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        apply(variants.find((v) => v.option === value));
      });
    });

    const selectedPill = pills.find((p) => p.getAttribute('aria-checked') === 'true');
    const currentVariant = () => {
      const pill = pills.find((p) => p.getAttribute('aria-checked') === 'true');
      return variants.find((v) => v.option === (pill ? pill.dataset.sizeValue : null));
    };
    apply(currentVariant());

    if (!discount) {
      detectDiscountFromCart().then((code) => {
        if (code && DISCOUNTS[code]) {
          discountCode = code;
          discount = DISCOUNTS[code];
          const v = currentVariant();
          if (v && v.priceCents) applyDiscountDisplay(v.priceCents);
        }
      });
    }

    document.querySelectorAll('[data-accordion-head]').forEach((head) => {
      head.addEventListener('click', () => {
        const open = head.getAttribute('aria-expanded') === 'true';
        head.setAttribute('aria-expanded', open ? 'false' : 'true');
        const item = head.parentElement;
        const body = item.querySelector('[data-accordion-body]');
        const vertical = item.querySelector('[data-accordion-vertical]');
        if (body) body.toggleAttribute('data-open', !open);
        if (vertical) vertical.toggleAttribute('data-open', !open);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-shipping-returns"]) return;
  try {
    
  (() => {
    const container = document.querySelector('[data-sr-accordion]');
    if (!container) return;

    const policies = {};
    document.querySelectorAll('template[data-sr-policy]').forEach((tpl) => {
      const key = tpl.dataset.srPolicy;
      const div = document.createElement('div');
      div.innerHTML = tpl.innerHTML;
      div.querySelectorAll('[style]').forEach((el) => el.removeAttribute('style'));
      policies[key] = div;
    });

    function extractSection(policyDiv, title) {
      if (!policyDiv) return '';
      const normalised = title.toLowerCase().replace(/&amp;/g, '&');
      const children = Array.from(policyDiv.children);
      let capturing = false;
      const parts = [];

      for (const child of children) {
        const text = child.textContent.trim().toLowerCase().replace(/&amp;/g, '&');
        const isBoldHeading = child.querySelector('strong') && text.length < 80;

        if (isBoldHeading && text === normalised) {
          capturing = true;
          continue;
        }

        if (capturing) {
          if (isBoldHeading && text !== normalised) break;
          parts.push(child.outerHTML);
        }
      }

      return parts.join('');
    }

    container.querySelectorAll('.accordion__item[data-sr-source]').forEach((item) => {
      const source = item.dataset.srSource;
      const titleEl = item.querySelector('.accordion__title');
      const contentEl = item.querySelector('.accordion__body-content');
      if (!titleEl || !contentEl) return;

      const html = extractSection(policies[source], titleEl.textContent.trim());
      if (html) {
        contentEl.innerHTML = html;
      } else {
        item.hidden = true;
      }
    });

    container.querySelectorAll('[data-accordion-head]').forEach((head) => {
      head.addEventListener('click', () => {
        const open = head.getAttribute('aria-expanded') === 'true';
        head.setAttribute('aria-expanded', open ? 'false' : 'true');
        const item = head.parentElement;
        const body = item.querySelector('[data-accordion-body]');
        const vertical = item.querySelector('[data-accordion-vertical]');
        if (body) body.toggleAttribute('data-open', !open);
        if (vertical) vertical.toggleAttribute('data-open', !open);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (() => {
    /* ── Countdown ─────────────────────────────────────────────────────── */
    const countdownRoot = document.querySelector('[data-countdown]');
    if (countdownRoot) {
      const target = Number(countdownRoot.dataset.target) * 1000;
      const serverNow = Number(countdownRoot.dataset.serverNow) * 1000;

      if (Number.isFinite(target) && Number.isFinite(serverNow)) {
        const skew = serverNow - Date.now();
        const els = {
          days: countdownRoot.querySelector('[data-countdown-days]'),
          hours: countdownRoot.querySelector('[data-countdown-hours]'),
          minutes: countdownRoot.querySelector('[data-countdown-minutes]'),
          seconds: countdownRoot.querySelector('[data-countdown-seconds]'),
        };
        const pad = (n) => String(n).padStart(2, '0');

        let timer;
        const tick = () => {
          const left = Math.max(0, target - (Date.now() + skew));
          const s = Math.floor(left / 1000);
          els.days.textContent = pad(Math.floor(s / 86400));
          els.hours.textContent = pad(Math.floor(s / 3600) % 24);
          els.minutes.textContent = pad(Math.floor(s / 60) % 60);
          els.seconds.textContent = pad(s % 60);
          if (left <= 0 && timer) clearInterval(timer);
        };

        tick();
        timer = setInterval(tick, 1000);
      }
    }

    /* ── Early access toggle ───────────────────────────────────────────── */
    const toggle = document.getElementById('AccessToggle');
    const panel = document.getElementById('AccessPanel');
    const accessPassword = document.getElementById('AccessPassword');

    function revealAccessPanel() {
      if (panel) panel.hidden = false;
      if (toggle) toggle.hidden = true;
      if (accessPassword) {
        setTimeout(() => {
          accessPassword.scrollIntoView({ behavior: 'smooth', block: 'center' });
          accessPassword.focus({ preventScroll: true });
        }, 100);
      }
    }

    if (toggle && panel) {
      toggle.addEventListener('click', revealAccessPanel);
    }

    if (panel && !panel.hidden && accessPassword) {
      accessPassword.focus({ preventScroll: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
